import api from './api';

export const getVehicleFormOptions = async () => (await api.get('/customer-vehicles/form-options')).data.data;

export const createCustomerVehicle = async (data: FormData) =>
  (await api.post('/customer-vehicles', data)).data;

export interface CustomerVehiclePagination {
  total_records: number;
  total_pages: number;
  page_number: number;
  page_size: number;
}

export interface CustomerVehiclesResponse {
  success: boolean;
  data: any[];
  total: number;
  pagination?: CustomerVehiclePagination;
}

export const getMyVehicles = async (
  params?: { page?: number; pageSize?: number; search?: string; status?: string } | string
): Promise<CustomerVehiclesResponse> => {
  const queryParams = typeof params === 'string' ? (params ? { search: params } : undefined) : params;
  return (await api.get('/customer-vehicles', { params: queryParams })).data;
};

export const getCustomerVehicle = async (id: string) =>
  (await api.get(`/customer-vehicles/${id}`)).data.data;

export const updateCustomerVehicle = async (id: string, data: FormData) =>
  (await api.put(`/customer-vehicles/${id}`, data)).data;
